import React, {Fragment} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Block, Edit} from '@material-ui/icons';
import {useStyles} from './style';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Grid, IconButton, InputAdornment, MuiThemeProvider, Tooltip } from '@material-ui/core';
import { createMuiTheme } from "@material-ui/core/styles";

export default function ComboBox(props) {
	const classes = useStyles();
    const [values, setValues] = React.useState({
        valor: '',
        active: props.disabled,
      });

    
    const handleClickShowPassword = () => {
        setValues({ ...values, active: !values.active });
      };
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };	
	return (
		<Fragment key={props.name}>
			{props?.showSelectAutoComplete && (
 			<Grid className={classes.grid} key={props.name}>
				{(props.value === "") ?
				// {(props.value === "" || props.value === 0) ?
					<div>
					<Autocomplete
						// id="controllable-states-demo"	
						id={props.name}
						name={props.name}
						onChange={(event, newValue) => {
							if(newValue !== null) {
								var event = {
									target: {value:newValue.id, name:props.name}
								}
								props.handleChange(event);
							}
						}}    
						autoComplete
						disabled={props.disabled}
						options={props.list}
						noOptionsText="No encontrado"
						getOptionLabel={(option) => option.name}
						renderInput={(params) =>
							<TextField 
								id={props.name}
								name={props.name}
								value={props.value}		
								{...params} label={props.label} className={classes.textField}
							/>
						}

					/>
					{(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
				</div>
					: props.list?.length >0 ?
					<div  className={classes.grid}>

					<Autocomplete 
						// id="controllable-states-demo"	
						id={props.name}
						name={props.name}								
						onChange={(event, newValue) => {
							if(newValue !== null) {
								var event = {
									target: {value:newValue.id, name:props.name}
								}
								props.handleChange(event);
							}
						}}    
						disabled={values.active}
						options={props.list}
						noOptionsText="No encontrado"
						getOptionLabel={(option) => option.name}
						defaultValue={props.list[props.position]}				
						renderInput={(params) =>
							props.modified ? 
							<>
								<Grid container alignItems="flex-end">
									<Grid item xs={10} >
										<TextField 
												id={props.name}
												name={props.name}
												value={props.value}		
												{...params} label={props.label} className={classes.textField}
											/>
									</Grid>
									<Grid item xs={2}>
										<InputAdornment position="start" className={classes.icon}>
											<Tooltip title={values.active ? "editar" : 'Bloquear'}>
											<IconButton 
												aria-label="toggle password visibility"
												onClick={handleClickShowPassword}
												onMouseDown={handleMouseDownPassword}
												>
												{values.active ? <Edit /> : <Block />}
											</IconButton>
											</Tooltip>
										</InputAdornment>							
									</Grid>									
								</Grid>						
							</>
							:
							<TextField 
							id={props.name}
							name={props.name}
							value={props.value}		
							{...params} label={props.label} className={classes.textField}
						/>							
						}
					/>
					{(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
				</div>
					: ""
					}
			</Grid>
		)}
		</Fragment>
	);
}

ComboBox.defaultProps = {
    showSelectAutoComplete: true
}